/* DS Wood — predictive search (products only, via Section Rendering API) */
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 220;
  var SECTION_ID = 'predictive-search-results';

  function fetchSectionHTML(term) {
    var url = '/search?q=' + encodeURIComponent(term)
      + '&type=product'
      + '&section_id=' + SECTION_ID;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
  }

  function extractFragment(html) {
    // The response from Section Rendering API is the full section HTML.
    // Look for our internal wrapper .predictive-search-fragment
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var frag = tmp.querySelector('.predictive-search-fragment');
    return frag ? frag.innerHTML : '';
  }

  function showLoading(container) {
    container.hidden = false;
    container.innerHTML = '<div class="predictive-search__loading">Recherche…</div>';
  }

  function showError(container, term) {
    container.hidden = false;
    container.innerHTML = '<div class="predictive-search__empty">Recherche indisponible. <a href="/search?q=' + encodeURIComponent(term) + '&type=product">Voir tous les résultats →</a></div>';
  }

  function render(container, html) {
    container.hidden = false;
    container.innerHTML = html && html.trim() ? html : '<div class="predictive-search__empty">Aucun produit trouvé.</div>';
  }

  function hide(container) {
    container.hidden = true;
    container.innerHTML = '';
  }

  function bind(wrapper) {
    var input = wrapper.querySelector('[data-predictive-input]');
    var results = wrapper.querySelector('[data-predictive-results]');
    if (!input || !results) return;

    var timer = null;
    var requestId = 0;

    function onInput() {
      var term = input.value.trim();
      if (timer) clearTimeout(timer);
      if (term.length < MIN_CHARS) {
        hide(results);
        return;
      }
      timer = setTimeout(function () {
        var myId = ++requestId;
        showLoading(results);
        fetchSectionHTML(term)
          .then(function (html) {
            if (myId !== requestId) return;
            var fragment = extractFragment(html);
            render(results, fragment);
          })
          .catch(function (err) {
            if (myId !== requestId) return;
            console.error('Predictive search failed:', err);
            showError(results, term);
          });
      }, DEBOUNCE_MS);
    }

    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS) onInput();
    });
    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) hide(results);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(results); input.blur(); }
    });
  }

  function init() {
    document.querySelectorAll('[data-predictive-search]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
